import React from "react";
import { Button, Result } from "antd";
import { useNavigate } from "react-router";

export const NotAuthorizedPage: React.FC = () => {
  const navigate = useNavigate();

  const redirectHandler = () => {
    navigate("/app/dashboard");
  };

  return (
    <Result
      status="403"
      title="403"
      subTitle="Désolé, vous n’êtes pas autorisé à accéder à cette page."
      extra={
        <Button type="primary" onClick={redirectHandler}>
          Accueil
        </Button>
      }
    />
  );
};
